import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import DatePicker from "react-datepicker";
// import Drag from '../../campaign/dragNdDropKycFile';
import Drag from "./dragNdDrop";
import { putServerDataWithPath } from "../../../action/common_action";
import "react-datepicker/dist/react-datepicker.css";

import { ANY_ERROR } from "../../../action/user_action_types";
import http from "../../../util/http";
import { endPoints, url } from "../../../config";
class UploadContract extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contract_file: null,
    };
  }

  //Upload a file
  getUploadedFile = (files) => {
    console.log(files);
    this.setState({ contract_file: files });
  };

  //Remove file
  removeFile = () => {
    console.log(this.props);
    this.setState({
      contract_file: null,
    });
  };

  uploadContractFile = async (e) => {
    e.preventDefault();
    console.log("Uploading contract");
    if (this.props.fileType === "Revised Traffic Order") {
      await this.generateProductionSale(
        this.props.updateObj,
        this.props.campaign
      );
      window.location.reload();
    } else {
      let { contract_file } = this.state;
      let formData = new FormData();
      formData.append("contractFile", contract_file);
      formData.append("status", this.props.status);
      formData.append("statusStages", this.props.statusStages);
      formData.append("_id", this.props.campaignId);
      formData.append("type", this.props.fileType);
      await this.props.updateContractToCampaign(
        endPoints.updateContractToCampaign,
        formData,
        "/admin/campaign"
      );
      window.location.reload();
    }
  };

  generateProductionSale = async (data, campaign) => {
    data.campaign = JSON.parse(JSON.stringify(campaign));
    data.updateObj.status = "On-Hold";
    data.updateObj.startDate = null;
    data.updateObj.audioCost = 0;
    data.updateObj.audioTotalCost = 0;
    data.updateObj.taxes = Math.floor(campaign.amount * 0.18);
    data.updateObj.totalCost = campaign.amount + data.updateObj.taxes;
    delete data.campaign._id;
    data.updateObj.bigFmAudio = "false";
    data.campaign.amount = campaign.audioCost;
    data.campaign.totalPackageCost = 0;
    data.campaign.pendingAmount = 0;
    (data.campaign.crossRefId = campaign._id),
      (data.campaign.packageDiscountedCost = 0);
    data.campaign.status = "Production Sale";
    data.campaign.name = `${campaign.name}_Audio`;
    data.campaign.taxes = Math.floor(campaign.audioCost * 0.18);
    data.campaign.totalCost = campaign.audioCost + data.campaign.taxes;
    data.campaign.statusStages = data.campaign.statusStages
      ? data.campaign.statusStages.push(data.updateObj.status)
      : [data.updateObj.status];
    let { contract_file } = this.state;
    let formData = new FormData();
    formData.append("contractFile", contract_file);
    formData.append("data", JSON.stringify(data));
    await this.props.updateCampaign(
      endPoints.updateProductionSale,
      formData,
      "/admin/campaign"
    );
  };

  render() {
    let { contract_file, campaignData } = this.state;
    return (
      <div>
        <div className="modal-overlay">
          <div
            className="modal-wrapper thankyou-popup"
            aria-modal
            aria-hidden
            tabIndex={-1}
            role="dialog"
          >
            <div className="modal">
              <div className="modal-head-cross rate-modal">
                <button
                  type="button"
                  className="modal-close-button"
                  onClick={() => this.props.hideUploadContract()}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="editNonFct-header modal-header">
                  <h4 className="popup-head rqst-head fct-head modal-title">
                    Upload {this.props.fileType} File
                  </h4>
                </div>
                <div className="editNonFct-modal modal-body">
                  <div className="bg-white">
                    <form className="form-group">
                      <div className="popupCampaign-container">
                        <div className="campaign-input master-inputs nonFct">
                          <div className="lenght_file_wrapper">
                            <div className="flie_audio">
                              {!contract_file && (
                                <div className="drag_nd_drp">
                                  <h6>{this.props.fileType} File</h6>
                                  <Drag
                                    getUploadedFile={this.getUploadedFile}
                                  />
                                </div>
                              )}

                              {contract_file && (
                                <div className="upload_file">
                                  <h6>Uploaded {this.props.fileType} File</h6>
                                  <div>
                                    <div className="audio_img">
                                      {" "}
                                      <img src="../../assets/images/text.svg" />
                                    </div>
                                    <div className="file_desc">
                                      <div className="file_name_size">
                                        <div className="file_name">
                                          {contract_file
                                            ? contract_file.path
                                            : ""}
                                        </div>
                                      </div>
                                      <div
                                        className="remove_file"
                                        onClick={this.removeFile}
                                      >
                                        <a>REMOVE</a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="create-camp nonfct-submit">
                          <button onClick={this.uploadContractFile}>
                            Upload
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showError: (error) =>
      dispatch({
        type: ANY_ERROR,
        payload: error,
      }),
    updateContractToCampaign: (url, data, path) =>
      dispatch(putServerDataWithPath(url, data, path)),
  };
};

export default connect(null, mapDispatchToProps)(UploadContract);



// WEBPACK FOOTER //
// ./web/components/admin/manageCampaign/UploadContract.jsx